import React from "react";
import { Spin } from "antd";
import { IIndexTypeCategoryPresenter } from "../../presenter/IndexTypeCategoryPresenter";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import IndexTypeCategoriesGrid from "../components/IndexTypeCategoriesGrid";

export interface Props extends PageProps {}

export interface State extends IIndexTypeCategoryPresenter {}

export default class IndexTypeCategoryListPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      createIndexTypeCategory,
      indexTypeCategories,
      showIndexTypeCategoryDetails,
      updateIndexTypeCategory,
      findConnectionCandidates,
      categoryCandidates,
      toggleCandidate,
      showBulkEditor
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.indexTypeCategoryLoader}>
            <IndexTypeCategoriesGrid
              translate={translate}
              createIndexTypeCategory={createIndexTypeCategory}
              indexTypeCategories={indexTypeCategories}
              referenceLoader={this.state.loaders.institutionLoader}
              showDetails={showIndexTypeCategoryDetails}
              updateIndexTypeCategory={updateIndexTypeCategory}
              findConnectionCandidates={findConnectionCandidates}
              categoryCandidates={categoryCandidates}
              toggleCandidate={toggleCandidate}
              showBulkEditor={showBulkEditor}
            />
          </Spin>
        }
      </Page>
    );
  }
}
